import { Stack } from "@similarweb/ui-components/foundations";

import { EmptyTrademarkState } from "../../shared/components/page-states";
import { useMonitorAndProtectTrademarkDataAndParams } from "../../shared/hooks/trademark-params";

import { TrademarkFilters } from "./filtres/trademark-filters";
import { TrademarkAdsTable } from "./table/trademark-table";

export const TrademarkDashboard = () => {
    const { trademarkId } = useMonitorAndProtectTrademarkDataAndParams();

    if (!trademarkId) {
        return <EmptyTrademarkState flex="1" />;
    }

    return (
        <Stack
            paddingX="40px"
            paddingY="32px"
            gap="24px"
            alignItems="flex-start"
        >
            <TrademarkFilters />
            <TrademarkAdsTable />
        </Stack>
    );
};
